<template>
  <div>
    <!-- <personel-extra-work-view-search-panel  @search="search" /> -->
    <personel-view-search-panel :accessTo="4"  @search="search" />

    <box class="mt-2" :title="$t('extraWorkList')">
      <div class="extraWorkList">
        <div v-if="list.length > 0">
          <person-extra-work-list-web
            @onClick="onClickEW"
            :list="list"
            class="hidden-sm-and-down"
          />
          <person-extra-work-list-mob
            @onClick="onClickEW"
            :list="list"
            class="hidden-md-and-up"
          />
          <div class="text-center">
            <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="5"
              @input="search"
            ></v-pagination>
          </div>
        </div>
        <!-- <div v-else>
          <EmptyList />
        </div> -->
      </div>
    </box>
  </div>
</template>

<script>
import PersonExtraWorkListMob from '../../components/request/PersonExtraWorkList/PersonExtraWorkListMob.vue';
import PersonExtraWorkListWeb from '../../components/request/PersonExtraWorkList/PersonExtraWorkListWeb.vue';
// import PersonelExtraWorkViewSearchPanel from '../../components/requestManagement/PersonelExtraWorkViewSearchPanel.vue';
// import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanel.vue";
import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanelWhitParam.vue";
export default {
  components: {
    PersonExtraWorkListWeb,
    PersonExtraWorkListMob,
    // PersonelExtraWorkViewSearchPanel,
    PersonelViewSearchPanel,
  },
  data() {
    return {
      pages: 1,
      page: 1,
      pagesize: 20,
      list: [],
    };
  },
  methods: {
    search(searchParams) {
       var GetExtraWorkParams = {
        beginDate: searchParams.beginDate,
        endDate: searchParams.endDate,
        //status: this.requestType.Code,
        status: searchParams.searchKind,
        perno: searchParams.perno,
        page: this.page,
        pagesize: this.pagesize,
      };
      //debugger
      if(GetExtraWorkParams.status==2){
        // this.requestType.Code=2
        GetExtraWorkParams.status=5
      }

      this.$store.dispatch("GetExtraWork", { GetExtraWorkParams }).then((result) => {
        //console.log(result);
        //debugger;
        if (result.type === "success") {
          if (result.response.TotalRow) {
              this.pages = Math.ceil(result.response.TotalRow / this.pagesize);
              //console.log(this.pages);
            }
          this.list = result.data;
          //this.getFilteredList(result.data, searchParams.searchKind);
        } else {
          this.list = [];
        }
      });
    },
   
    onClickEW(){},
  },
};
</script>

<style>
</style>